import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase, unwrap } from '../lib/supabase';
import { cx } from './ui';

const STYLE: Record<string, string> = {
  owned: 'bg-emerald-100 text-emerald-800',
  leased: 'bg-sky-100 text-sky-800',
  unknown: 'bg-slate-100 text-slate-600',
};

/** Owned / leased / unknown, editable in place — the distinction that matters for tenants. */
export function TenureSelect({ locationId, tenure, invalidate }: { locationId: string; tenure: string; invalidate: unknown[][] }) {
  const qc = useQueryClient();
  const save = useMutation({
    mutationFn: async (t: string) => unwrap(await supabase.from('org_locations').update({ tenure: t }).eq('id', locationId)),
    onSuccess: () => invalidate.forEach((k) => qc.invalidateQueries({ queryKey: k })),
  });
  return (
    <select
      value={tenure}
      onChange={(e) => save.mutate(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      className={cx('cursor-pointer rounded-full border-0 py-0.5 pl-2 pr-6 text-xs font-medium', STYLE[tenure])}
      aria-label="Tenure"
    >
      <option value="unknown">unknown</option>
      <option value="owned">owned</option>
      <option value="leased">leased</option>
    </select>
  );
}
